import UnderlinedText from "./underlined_text";
import { Grid, Typography } from "@mui/material";
import { fieldHeader } from "../../../../components/fields/field_header";

const ViewStoreInformation = ({ data }: any) => {
  return (
    <>
      <Grid item xs={12}>
        <Typography variant="h6" color={"white"} bgcolor={"red"} p={0.5}>
          STORE INFORMATION:
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Grid item>{fieldHeader("Store Name", true)}</Grid>
        <UnderlinedText text={data.storeName} />
      </Grid>
      <Grid item xs={12}>
        <Grid item>{fieldHeader("Store Physical Address", true)}</Grid>
        <UnderlinedText text={data.storeAddress} />
      </Grid>
      <Grid item xs={12} md={4}>
        <Grid item>{fieldHeader("Physical City", true)}</Grid>
        <UnderlinedText text={data.storeCity} />
      </Grid>
      <Grid item xs={12} md={4}>
        <Grid item>{fieldHeader("Physical State", true)}</Grid>
        <UnderlinedText text={data.storeState} />
      </Grid>
      <Grid item xs={12} md={4}>
        <Grid item>{fieldHeader("Physical ZIP", true)}</Grid>
        <UnderlinedText text={data.storeZip} />
      </Grid>
      <Grid item xs={12}>
        <Grid item>{fieldHeader("Store Billing Address", false)}</Grid>
        <UnderlinedText text={data.storeBillingAddress} />
      </Grid>
      <Grid item xs={12} md={4}>
        <Grid item>{fieldHeader("Billing City", false)}</Grid>
        <UnderlinedText text={data.storeBillingCity} />
      </Grid>
      <Grid item xs={12} md={4}>
        <Grid item>{fieldHeader("Billing State", false)}</Grid>
        <UnderlinedText text={data.storeBillingState} />
      </Grid>
      <Grid item xs={12} md={4}>
        <Grid item>{fieldHeader("Billing ZIP", false)}</Grid>
        <UnderlinedText text={data.storeBillingZip} />
      </Grid>
      <Grid item xs={12} md={6}>
        <Grid item>{fieldHeader("P.O. Box", false)}</Grid>
        <UnderlinedText text={data.poBox} />
      </Grid>
      <Grid item xs={12} md={6}>
        <Grid item>{fieldHeader("P.O. Box City", false)}</Grid>
        <UnderlinedText text={data.poBoxCity} />
      </Grid>
      <Grid item xs={12} md={6}>
        <Grid item>{fieldHeader("P.O. Box State", false)}</Grid>
        <UnderlinedText text={data.poBoxState} />
      </Grid>
      <Grid item xs={12} md={6}>
        <Grid item>{fieldHeader("P.O. Box ZIP", false)}</Grid>
        <UnderlinedText text={data.poBoxZip} />
      </Grid>
      <Grid item xs={12} md={4}>
        <Grid item>{fieldHeader("Store Phone", true)}</Grid>
        <UnderlinedText text={data.storePhone} />
      </Grid>
      <Grid item xs={12} md={4}>
        <Grid item>{fieldHeader("Store Email", true)}</Grid>
        <UnderlinedText text={data.storeEmail} />
      </Grid>
      <Grid item xs={12} md={4}>
        <Grid item>{fieldHeader("Store Website", false)}</Grid>
        <UnderlinedText text={data.storeWebsite} />
      </Grid>
      <Grid item xs={12} md={4}>
        <Grid item>{fieldHeader("# Checkouts", false)}</Grid>
        <UnderlinedText text={data.numCheckouts} />
      </Grid>
      <Grid item xs={12} md={4}>
        <Grid item>{fieldHeader("# Self Checkouts", false)}</Grid>
        <UnderlinedText text={data.numSelfCheckouts} />
      </Grid>
      <Grid item xs={12} md={4}>
        <Grid item>{fieldHeader("Type of POS System", true)}</Grid>
        <UnderlinedText text={data.posSystem} />
      </Grid>
    </>
  );
};

export default ViewStoreInformation;
